import { render, staticRenderFns } from "./paymentHistory.vue?vue&type=template&id=60be8da4&scoped=true&"
import script from "./paymentHistory.vue?vue&type=script&lang=js&"
export * from "./paymentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60be8da4",
  null
  
)

export default component.exports